import React, { useEffect, useState } from "react";
import useSelector from "../../store/useSelector";
import "./ProcessTimeRCModal.scoped.scss";
import loaderGif from "media/gifs/loader.gif";
import { useDispatch } from "react-redux";
import { getTimeRCProcessingRequestStatus } from "store/swList/swListActions";

const ProcessTimeRCModal: React.FC = () => {
    const { timeRCRequestData } = useSelector(store => store.swList);
    const [isClose] = useState(false);
    const { SW } = useSelector(store => store.manageSW)
    const dispatch = useDispatch();

    const getStatus = () => {
        let requestIds: string = "";
        timeRCRequestData.forEach(element => {
            requestIds = requestIds + element.requestId + ",";
        });
        // remove , character
        requestIds = requestIds.slice(0, -1);
        dispatch(getTimeRCProcessingRequestStatus({
            requestIds: requestIds,
            swGuid: SW.guid,
            swVersion: SW.version
        }));
    }

    useEffect(() => {
        if ((timeRCRequestData.length > 0) && !isClose) {
            const timer = setInterval(getStatus, 15000);
            return () => clearInterval(timer);
        }
    }, [timeRCRequestData, isClose]);

    return (
        <>
            {
                ((timeRCRequestData.length > 0) && !isClose) &&
                <div className="main-area">
                    <div className="fade"></div>
                    <div className="modal">
                        <div className="modal-content">
                            <img className="modal-loading-img" src={loaderGif} alt="loading..." />
                            <div className="modal-data">
                                <div className="modal-header"><b>TIME RC update is in progress.</b></div>
                                <p className="modal-body">You can't do any modifications.</p>
                            </div>
                        </div>
                    </div>
                </div>
            }
        </>
    );
};
export default ProcessTimeRCModal;